module.exports = __webpack_public_path__ + "img/22.aaf3d54c.png";